import * as React from 'react';

const COLORS = {
  color_dark: '#2E2E2E',
  color_yellow: '#FFED00',
  color_dark_bleu: '#2C4965',
  color_white: '#ffffff'
};

export function AccessibiliteIcon(props) {
  return (
    <svg width={18} height={18} viewBox="0 0 18 18" {...props} aria-hidden="true">
      <g
        transform="translate(1 1.298) translate(-1 -1.298)"
        stroke="#fff"
        strokeWidth="2px"
        fill="none"
      >
        <circle cx={9} cy={9} r={9} stroke="none" />
        <circle cx={9} cy={9} r={8} />
      </g>
      <path
        d="M8.417 3.118A.417.417 0 008 3.535v8.333a.417.417 0 00.417.417 4.583 4.583 0 100-9.167z"
        fill="#fff"
        transform="translate(1 1.298)"
      />
    </svg>
  );
}

export function MaqsueBannerCardProduct(props) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 349 101.1" {...props}>
      <defs>
        <clipPath id={'clip-path' + props.clipPath}>
          <path
            id="CEst_CNP_Gds_Tvx_-_Re\u0301fection_A6_Yonne_-_2016"
            data-name="CEst + CNP + Gds Tvx - Re\u0301fection A6 Yonne - 2016"
            d="M1248.049,911.525h-349v-101.1l199.267,81.485c10.931,4.451,24.139,12.448,38.614,12.268,14.536.241,30.688-7.695,41.734-12.208l69.385-27.595Z"
            transform="translate(-5287.549 -14731.926)"
            fill="#e0e0e0"
          />
        </clipPath>
      </defs>
      <g
        id="Mask_Group_4"
        data-name="Mask Group 4"
        transform="translate(4388.5 13921.5)"
        clipPath={'url(#clip-path' + props.clipPath + ')'}
      >
        <rect
          id="Rectangle_4371"
          data-name="Rectangle 4371"
          width={350}
          height={103}
          transform="translate(-4389 -13923)"
          fill="#2c4965"
        />
      </g>
    </svg>
  );
}

export function IconDeploySelector(props) {
  return (
    <svg width={9.294} height={6.07} viewBox="0 0 9.294 6.07" {...props} aria-hidden="true">
      <path
        d="M3.224 5.486l.01-.011L.586 2.828A2 2 0 01.586 0l4.062 4.061L8.709.001a2 2 0 010 2.828L6.062 5.475l.01.01a2.027 2.027 0 01-2.848 0z"
        fill="#fff"
      />
    </svg>
  );
}

export function IconDeploySelectorBig(props) {
  const { color } = props;
  return (
    <svg
      data-name="Calque 1"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 34.74 22.82"
      {...props}
      aria-hidden="true"
    >
      <path
        d="M17.76 11.5l7.58 9.82a3.88 3.88 0 003.05 1.5h5.87a.48.48 0 00.48-.48.45.45 0 00-.1-.3L17.76.19a.5.5 0 00-.69-.09L17 .19.1 22a.49.49 0 00.09.68.54.54 0 00.3.1h5.87a3.86 3.86 0 003-1.5L17 11.5a.49.49 0 01.68-.09l.09.09"
        fill={color ? COLORS[color] : COLORS.color_yellow}
      />
    </svg>
  );
}

export function BGArrowPointerTopRight(props) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={1366}
      height={418}
      viewBox="0 0 1366 418"
      aria-hidden="true"
      {...props}
    >
      <path
        d="M1012.093 6.427L0 395.769V418h1366V111L1096.575 6.482c-11.554-4.493-26.9-6.648-42.063-6.471q-.9-.012-1.8-.011c-14.747 0-29.459 2.105-40.619 6.427z"
        fill="#c1c9d2"
      />
    </svg>
  );
}

export function SearchIcon(props) {
  return (
    <svg width={23.95} height={23.95} viewBox="0 0 23.95 23.95" {...props} aria-hidden="true">
      <path
        d="M1400.88 1246.465l5.656 5.657a2 2 0 010 2.828l-8.485-8.485a2 2 0 012.828 0z"
        transform="translate(-1384 -1231)"
      />
      <g
        transform="translate(-1384 -1231) translate(1384 1231)"
        stroke="#000"
        strokeWidth="2px"
        fill="none"
      >
        <circle cx={8} cy={8} r={7} />
      </g>
    </svg>
  );
}

export function RoundedArrow(props) {
  const { color } = props;
  return (
    <svg width={29.8} height={29.8} viewBox="0 0 29.8 29.8" {...props} aria-hidden="true">
      <circle fill={color ? COLORS[color] : COLORS.color_yellow} cx={14.9} cy={14.9} r={14.9} />
      <path
        fill={color == 'color_dark_bleu' ? '#ffffff' : '#2c4965'}
        d="M25.153 14.255l-.009-.009c-.01-.013-15.291-10.564-15.291-10.564a3.994 3.994 0 00-.783 4.079c.6 1.226 3.2 2.9 3.914 3.341 1.51 1.048 4.686 3.15 4.689 3.153.3.219.393.374.388.6a.959.959 0 01-.383.681s-3.137 2.079-4.634 3.116c-.612.377-3.351 2.114-3.974 3.379a3.985 3.985 0 00.771 4.062l.012.021S25.134 15.563 25.144 15.55l.013-.015a.958.958 0 00.383-.681c.007-.22-.09-.376-.387-.599z"
      />
    </svg>
  );
}

export function ListArrow(props) {
  const { color } = props;
  return (
    <svg width={50} height={60} viewBox="0 0 29.8 29.8" {...props} aria-hidden="true">
      <path
        fill={color == 'color_yellow' && '#ffed00'}
        d="M25.153 14.255l-.009-.009c-.01-.013-15.291-10.564-15.291-10.564a3.994 3.994 0 00-.783 4.079c.6 1.226 3.2 2.9 3.914 3.341 1.51 1.048 4.686 3.15 4.689 3.153.3.219.393.374.388.6a.959.959 0 01-.383.681s-3.137 2.079-4.634 3.116c-.612.377-3.351 2.114-3.974 3.379a3.985 3.985 0 00.771 4.062l.012.021S25.134 15.563 25.144 15.55l.013-.015a.958.958 0 00.383-.681c.007-.22-.09-.376-.387-.599z"
      />
    </svg>
  );
}

export function CloseIcon(props) {
  const { fill, customCLass } = props;
  return (
    <svg className={customCLass} xmlns="http://www.w3.org/2000/svg" width="12.971" height="12.142" viewBox="0 0 12.971 12.142" aria-hidden="true"><path fill={fill} d="M245.878,724.846l3.656-3.657a2,2,0,0,0,0-2.828l-5.071,5.071-5.071-5.071a2,2,0,0,0,0,2.828l3.657,3.657-5.071,5.071a2,2,0,0,0,2.828,0l3.657-3.657,3.657,3.657a2,2,0,0,0,2.829,0Z" transform="translate(-237.978 -718.361)" /></svg>
  );
}

export function CloseIconThin(props) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" aria-hidden="true" width="21.213" height="21.215" viewBox="0 0 21.213 21.215"><g transform="translate(-53.393 -48.786)"><path d="M2,0H26a2,2,0,0,1,2,2V2a0,0,0,0,1,0,0H0A0,0,0,0,1,0,2V2A2,2,0,0,1,2,0Z" transform="translate(54.808 48.788) rotate(45)" /><path d="M2,0H26a2,2,0,0,1,2,2V2a0,0,0,0,1,0,0H0A0,0,0,0,1,0,2V2A2,2,0,0,1,2,0Z" transform="translate(53.393 68.585) rotate(-45)" /></g></svg>
  );
}

export function ArrowIconGoRight(props) {
  const fill = props.fill;
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="27.036" height="17.293" viewBox="0 0 27.036 17.293" aria-hidden="true"><g transform="translate(0)" fill={fill}><g transform="translate(-418 -625.353)"><path d="M444.449,632.6l-6.657-6.657a2,2,0,0,0-2.828,0l9.485,9.485A2,2,0,0,0,444.449,632.6Z" /><path d="M437.794,642.061l6.656-6.657a2,2,0,0,0,0-2.828l-9.485,9.485A2,2,0,0,0,437.794,642.061Z" /><path d="M438,633H420a2,2,0,0,0-2,2h22A2,2,0,0,0,438,633Z" /></g></g></svg>
  );
}

export function ArrowIconGoLeft({ color }) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 27.036 17.293" aria-hidden="true">
      <g transform="translate(0)">
        <path fill={COLORS[color] || '#00000'} d="M435.55,632.6l6.657-6.657a2,2,0,0,1,2.828,0l-9.485,9.485A2,2,0,0,1,435.55,632.6Z" transform="translate(-434.963 -625.353)" />
        <path fill={COLORS[color] || '#00000'} d="M442.207,642.061l-6.656-6.657a2,2,0,0,1,0-2.828l9.485,9.485A2,2,0,0,1,442.207,642.061Z" transform="translate(-434.965 -625.353)" />
        <path fill={COLORS[color] || '#00000'} d="M420,633h18a2,2,0,0,1,2,2H418A2,2,0,0,1,420,633Z" transform="translate(-412.964 -625.353)" />
      </g>
    </svg>
  );
}

export function InstagramIcon(props) {
  const fill = (props.fill) ? props.fill : '#ffffff';
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="23.333" height="23.333" viewBox="0 0 23.333 23.333" aria-hidden="true">
      <path data-name="Path 2400" d="M42.463,66q.052,1.46.052,4.845t-.078,4.868a9.857,9.857,0,0,1-.442,2.578,6.1,6.1,0,0,1-3.7,3.7,9.866,9.866,0,0,1-2.578.443q-1.485.077-4.87.078t-4.87-.078a8.592,8.592,0,0,1-2.578-.5,5.567,5.567,0,0,1-2.265-1.38A6.077,6.077,0,0,1,19.7,78.294a9.785,9.785,0,0,1-.443-2.578q-.078-1.482-.078-4.868t.078-4.87A9.785,9.785,0,0,1,19.7,63.4a6.089,6.089,0,0,1,3.7-3.7,9.878,9.878,0,0,1,2.578-.443q1.485-.078,4.87-.077t4.87.077A9.866,9.866,0,0,1,38.3,59.7a6.1,6.1,0,0,1,3.7,3.7A10.677,10.677,0,0,1,42.463,66Zm-2.5,11.72a11.008,11.008,0,0,0,.417-2.813q.052-1.145.052-3.228V70.014q0-2.138-.052-3.23a10.458,10.458,0,0,0-.417-2.812,3.759,3.759,0,0,0-2.24-2.24,10.4,10.4,0,0,0-2.812-.417q-1.147-.052-3.23-.052H30.014q-2.082,0-3.228.052a10.92,10.92,0,0,0-2.813.417,3.759,3.759,0,0,0-2.24,2.24,10.458,10.458,0,0,0-.417,2.812q-.05,1.145-.052,3.23v1.667q0,2.083.052,3.228a11.007,11.007,0,0,0,.417,2.813,3.952,3.952,0,0,0,2.24,2.238,10.92,10.92,0,0,0,2.813.417q1.145.052,3.228.053h1.667q2.135,0,3.23-.053a10.4,10.4,0,0,0,2.812-.417A3.947,3.947,0,0,0,39.963,77.723ZM30.848,64.858a5.826,5.826,0,0,1,2.995.807,6.016,6.016,0,0,1,2.188,2.188,5.96,5.96,0,0,1,0,5.988,6.016,6.016,0,0,1-2.188,2.188,5.963,5.963,0,0,1-5.99,0,6.011,6.011,0,0,1-2.187-2.188,5.95,5.95,0,0,1,0-5.988,6.011,6.011,0,0,1,2.187-2.188A5.826,5.826,0,0,1,30.848,64.858Zm0,9.895a3.912,3.912,0,1,0-2.76-1.145A3.762,3.762,0,0,0,30.848,74.753ZM38.5,64.6A1.4,1.4,0,1,0,37.1,66a1.266,1.266,0,0,0,.963-.417A1.613,1.613,0,0,0,38.5,64.6Z" transform="translate(-19.181 -59.181)" fill={fill} />
    </svg>
  );
}
export function FacebookIcon(props) {
  const fill = (props.fill) ? props.fill : '#ffffff';
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="13.022" height="25" viewBox="0 0 13.022 25" aria-hidden="true">
      <path data-name="Path 2401" d="M61.712,83.681V72.156h3.9l.587-4.427H61.712v-2.8a2.594,2.594,0,0,1,.39-1.563,2.259,2.259,0,0,1,1.758-.587H66.2v-3.9a24.58,24.58,0,0,0-3.385-.2,5.593,5.593,0,0,0-4.135,1.528,5.765,5.765,0,0,0-1.53,4.265v3.255H53.182v4.427h3.972V83.681Z" transform="translate(-53.182 -58.681)" fill={fill} />
    </svg>
  );
}
export function TwitterIcon(props) {
  const fill = (props.fill) ? props.fill : '#ffffff';
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="25" height="20.312" viewBox="0 0 25 20.312" aria-hidden="true">
      <path data-name="Path 2402" d="M103.458,65.8a14.475,14.475,0,0,1-1.71,6.788A13.939,13.939,0,0,1,96.816,78.1,14.082,14.082,0,0,1,88.858,80.4,14.226,14.226,0,0,1,81,78.1q.537.05,1.222.05a10.161,10.161,0,0,0,6.4-2.2,4.769,4.769,0,0,1-3-1,5.113,5.113,0,0,1-1.783-2.515c.327.032.635.048.928.048a6.459,6.459,0,0,0,1.367-.147,5.152,5.152,0,0,1-2.928-1.807,4.913,4.913,0,0,1-1.173-3.222v-.1a4.819,4.819,0,0,0,2.295.683,5.7,5.7,0,0,1-1.66-1.855,4.971,4.971,0,0,1,.1-5.03A14.335,14.335,0,0,0,93.3,66.385a7.126,7.126,0,0,1-.1-1.172,5.072,5.072,0,0,1,.685-2.563,5,5,0,0,1,1.855-1.88,5.089,5.089,0,0,1,4.613-.245,5.809,5.809,0,0,1,1.685,1.173,10.422,10.422,0,0,0,3.272-1.222,5.083,5.083,0,0,1-2.247,2.832,11,11,0,0,0,2.93-.83,11.294,11.294,0,0,1-2.588,2.687A2.835,2.835,0,0,1,103.458,65.8Z" transform="translate(-80.996 -60.087)" fill={fill} />
    </svg>
  );
}
export function XIcon(props) {
  const fill = (props.fill) ? props.fill : '#ffffff';
  return (
    <svg xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" viewBox="0 0 351.3 367.9">
      <path fill={fill} d="M205.6,155.8L339.6,0h-31.8L191.5,135.3L98.5,0H-8.7l140.5,204.5L-8.7,367.9h31.8L146,225.1l98.2,142.8h107.2L205.6,155.8L205.6,155.8z M162.1,206.3L147.8,186L34.5,23.9h48.8l91.4,130.8l14.2,20.4l118.9,170h-48.8L162.1,206.3L162.1,206.3z" />
    </svg>
  );
}
export function YoutubeIcon(props) {
  const fill = (props.fill) ? props.fill : '#ffffff';
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="25" height="17.582" viewBox="0 0 25 17.582" aria-hidden="true">
      <path data-name="Path 2403" d="M140.725,63.653a20.743,20.743,0,0,1,.458,3.755l.045,2.29-.045,2.288a20.941,20.941,0,0,1-.458,3.8,3.241,3.241,0,0,1-2.243,2.2,32.607,32.607,0,0,1-5.587.458l-4.167.045-4.167-.045a32.58,32.58,0,0,1-5.585-.458,3.248,3.248,0,0,1-2.245-2.2,20.974,20.974,0,0,1-.457-3.8l-.047-2.288q0-1.007.047-2.29a20.776,20.776,0,0,1,.457-3.755,3.2,3.2,0,0,1,2.245-2.243,32.579,32.579,0,0,1,5.585-.458l4.167-.045,4.167.045a32.607,32.607,0,0,1,5.587.458,3.193,3.193,0,0,1,2.243,2.243Zm-14.56,9.8,6.547-3.753-6.547-3.71Z" transform="translate(-116.228 -60.906)" fill={fill} />
    </svg>
  );
}
export function LinkedinIcon(props) {
  const fill = (props.fill) ? props.fill : '#ffffff';
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="23.333" height="23.333" viewBox="0 0 23.333 23.333" aria-hidden="true">
      <path data-name="Path 2404" d="M152.957,63.973a2.767,2.767,0,1,1,1.978.833A2.7,2.7,0,0,1,152.957,63.973Zm-.47,18.542V66.941h4.845V82.514Zm18.125,0V74.909A8.416,8.416,0,0,0,170.3,72.2a2.194,2.194,0,0,0-2.24-1.407,2.44,2.44,0,0,0-2.343,1.25,5.822,5.822,0,0,0-.522,2.762v7.708H160.4V66.941h4.637v2.135h.052a4.16,4.16,0,0,1,1.667-1.718,5.125,5.125,0,0,1,2.917-.833q3.385,0,4.74,2.135a10.549,10.549,0,0,1,1.042,5.313v8.542Z" transform="translate(-152.124 -59.181)" fill={fill} />
    </svg>
  );
}

export function HomeIcon(props) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="27.94" height="26.972" viewBox="0 0 27.94 26.972" aria-hidden="true"><g transform="translate(-309.821 -639.307)" fill={props.fill}><path d="M325.206,639.893l11.97,11.971a2,2,0,0,1,0,2.828h0l-14.8-14.8h0A2,2,0,0,1,325.206,639.893Z" /><path d="M322.377,639.893l-11.97,11.971a2,2,0,0,0,0,2.828h0l14.8-14.8h0A2,2,0,0,0,322.377,639.893Z" /><path d="M334.729,650.087a1,1,0,0,0-1,1v12.552a.641.641,0,0,1-.64.64H314.495a.641.641,0,0,1-.641-.64V651.087a1,1,0,0,0-2,0v12.552a2.643,2.643,0,0,0,2.641,2.64h18.594a2.643,2.643,0,0,0,2.64-2.64V651.087A1,1,0,0,0,334.729,650.087Z" /><path d="M325.433,654.654h-3.282a2.862,2.862,0,0,0-2.859,2.86v7.765a1,1,0,0,0,1,1h7a1,1,0,0,0,1-1v-7.765A2.862,2.862,0,0,0,325.433,654.654Zm.859,2.86v6.765h-5v-6.765a.861.861,0,0,1,.859-.86h3.282A.861.861,0,0,1,326.292,657.514Z" /></g></svg>
  );
}

export function ScrollIconSVG(props) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      x="0px"
      y="0px"
      viewBox="0 0 22 48"
      xmlSpace="preserve"
      aria-hidden="true"
      {...props}
    >
      <path
        d="M17.2 33.8c-.6 0-1-.4-1-1 0-.3.1-.6.4-.8 2.2-1.7 3.4-4.3 3.4-7V11c0-5-4-9-9-9s-9 4-9 9v14c0 2.7 1.2 5.3 3.3 7 .4.3.5 1 .1 1.4-.3.4-1 .5-1.4.1-2.5-2-4-5.2-4-8.5V11C0 4.9 4.9 0 11 0s11 4.9 11 11v14c0 3.4-1.5 6.5-4.2 8.6-.1.2-.4.2-.6.2z"
        transform="translate(9 6) translate(-184.225 -801.723) translate(175.23 795.72)"
      />
      <g className="arrow">
        <path
          d="M12 41V26c0-1.1-.9-2-2-2v19c1.1 0 2-.9 2-2zM12.4 47.4l6.7-6.7c.8-.8.8-2 0-2.8l-9.5 9.5c.8.8 2 .8 2.8 0z"
          transform="translate(9 6) translate(-184.225 -801.723) translate(175.23 795.72)"
        />
        <path
          d="M2.9 40.8l6.7 6.7c.8.8 2 .8 2.8 0L2.9 38c-.7.7-.7 2 0 2.8z"
          transform="translate(9 6) translate(-184.225 -801.723) translate(175.23 795.72)"
        />
      </g>
      <g>
        <path
          d="M12 13V9c0-1.3-2-1.2-2 .1v4c0 .6.4 1 1 1 .5 0 .9-.3 1-.8V13z"
          transform="translate(9 6) translate(-9 -6)"
        />
      </g>
    </svg>
  );
}

export function CoputerIcon(props) {
  const { color } = props;
  return (
    <svg
      data-name="CoputerIcon"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 28.72 24.1"
    >
      <g data-name="Icon Screen">
        <path
          data-name="Rectangle 1458"
          d="M9.36 22.1h11a2 2 0 012 2h-15a2 2 0 012-2z"
          fill={color || '#000000'}
        />
        <path
          data-name="Path 2408"
          d="M24.72 2a2 2 0 012 2v12.1a2 2 0 01-2 2H4a2 2 0 01-2-2V4a2 2 0 012-2h20.72m0-2H4a4 4 0 00-4 4v12.1a4 4 0 004 4h20.72a4 4 0 004-4V4a4 4 0 00-4-4z"
          fill={color || '#000000'}
        />
      </g>
    </svg>
  );
}

export function QuoteIconFrench(props) {
  const { direction } = props;
  return (
    <>
      {direction === 'right' ? (
        <svg xmlns="http://www.w3.org/2000/svg" width="44.242" height="59.154" viewBox="0 0 44.242 59.154" aria-hidden="true"><g fill="#ffe800"><path d="M651.388,283.035v.007a2.45,2.45,0,0,1,0,2.954V286s-9.154,12.987-9.672,13.75c-2.983,4.392-1.771,10.692,1.9,14.708l21.308-28.709v0a2.565,2.565,0,0,0,0-2.46v0l-14.739-18.333a11.08,11.08,0,0,0-1.074,13.979C649.63,279.694,651.388,283.035,651.388,283.035Z" transform="translate(-640.036 -255.307)" /><path d="M665.347,285.651v.007a2.45,2.45,0,0,1,0,2.954v.007s-9.154,12.987-9.672,13.75a11.076,11.076,0,0,0,1.076,13.978l22.134-27.979v0a2.565,2.565,0,0,0,0-2.46v0l-22.134-27.979a11.076,11.076,0,0,0-1.076,13.978C656.194,272.664,665.347,285.651,665.347,285.651Z" transform="translate(-634.957 -257.923)" /></g></svg>
      ) : (
        <svg xmlns="http://www.w3.org/2000/svg" width="44.242" height="59.154" viewBox="0 0 44.242 59.154" aria-hidden="true"><g fill="#ffe800"><path d="M625.585,289.349v-.007a2.45,2.45,0,0,1,0-2.954v-.007s9.155-12.987,9.672-13.75c2.983-4.392,1.773-10.692-1.9-14.708l-21.308,28.709v0a2.565,2.565,0,0,0,0,2.46v0l14.739,18.333a11.08,11.08,0,0,0,1.074-13.979C627.345,292.69,625.585,289.349,625.585,289.349Z" transform="translate(-592.695 -257.923)" /><path d="M611.709,289.151v-.007a2.45,2.45,0,0,1,0-2.954v-.007s9.155-12.987,9.672-13.75a11.078,11.078,0,0,0-1.074-13.978l-22.135,27.979v0a2.565,2.565,0,0,0,0,2.46v0l22.135,27.979a11.078,11.078,0,0,0,1.074-13.978C620.864,302.138,611.709,289.151,611.709,289.151Z" transform="translate(-597.858 -257.725)" /></g></svg>
      )
      }
    </>
  );
}

export function ComputerIcon(props) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="44.242" height="40" viewBox="0 0 28.7 24.1" aria-hidden="true">
      <g transform="translate(-842.269 -747.816)">
        <g transform="translate(886.411 789.218)">
          <path d="M-34.8-19.3h11c1.1,0,2,0.9,2,2h-15C-36.8-18.4-35.9-19.3-34.8-19.3z" />
          <path d="M-19.4-39.4c1.1,0,2,0.9,2,2v12.1c0,1.1-0.9,2-2,2h-20.7c-1.1,0-2-0.9-2-2v-12.1c0-1.1,0.9-2,2-2H-19.4 M-19.4-41.4h-20.7
          c-2.2,0-4,1.8-4,4v12.1c0,2.2,1.8,4,4,4h20.7c2.2,0,4-1.8,4-4v-12.1C-15.4-39.6-17.2-41.4-19.4-41.4z"/>
        </g>
      </g>
    </svg>
  );
}

export function LogoYellow(props) {
  const fill = (props.fill) ? props.fill : '#ffed00';
  return (
    <svg className="logo-yellow" xmlns="http://www.w3.org/2000/svg" width="223.995" height="72.79" viewBox="0 0 223.995 72.79" aria-hidden="true">
      <path data-name="Path 1886" d="M202.029,494.221,111.9,459.247a9.017,9.017,0,0,0-5.651,0l-2.175.842,87.1,33.8a1.5,1.5,0,0,1,0,2.863l-86.725,33.495,2.259.879a8.977,8.977,0,0,0,5.65,0L202.029,496.5c.679-.263,1.075-.675,1.075-1.134S202.712,494.492,202.029,494.221Z" transform="translate(1.602 -458.793)" fill={fill} />
      <path data-name="Path 1887" d="M206.23,494.068l-89.562-34.745a9.065,9.065,0,0,0-5.655,0l-2.175.842,86.537,33.578a1.5,1.5,0,0,1,0,2.863L109.73,529.688l2.259.879a9,9,0,0,0,5.646.008l88.6-34.224c.683-.267,1.075-.68,1.075-1.134S206.918,494.339,206.23,494.068Z" transform="translate(16.69 -458.552)" fill={fill} />
      <g data-name="Group 1790" transform="translate(0 0.441)">
        <path data-name="Path 1888" d="M263.035,493.924,174.3,459.35a8.107,8.107,0,0,0-2.913-.45h0a8.214,8.214,0,0,0-2.938.446l-88.7,34.315c-1.367.529-1.375,1.6-.008,2.129l88.737,34.578a8.172,8.172,0,0,0,2.913.446h0a8.145,8.145,0,0,0,2.938-.442l88.7-34.32C264.389,495.524,264.4,494.453,263.035,493.924Z" transform="translate(-78.714 -458.899)" fill={fill} />
        <g data-name="Group 1789" transform="translate(44.367 25.528)">
          <g data-name="Group 1788">
            <g data-name="Group 1787">
              <path data-name="Path 1889" d="M112.4,467.846a11.767,11.767,0,0,0-15.264-.012,10.026,10.026,0,0,0-3.034,7.58,10.191,10.191,0,0,0,3.021,7.592,11.762,11.762,0,0,0,15.26.013,11.013,11.013,0,0,0,.017-15.172Zm-3.709,11.63a5.169,5.169,0,0,1-3.938,1.571,5.031,5.031,0,0,1-3.93-1.58,6.294,6.294,0,0,1,.008-8.088,5.689,5.689,0,0,1,7.863,0,5.68,5.68,0,0,1,1.475,4.046A5.758,5.758,0,0,1,108.695,479.476Z" transform="translate(-74.333 -465.012)" />
              <path data-name="Path 1890" d="M105.182,465.151l-5.1,0-.007,19.84h12.82l-.006-4.773-7.706,0Z" transform="translate(-55.441 -464.638)" />
              <path data-name="Path 1891" d="M99.479,481.043a4.377,4.377,0,0,1-3.438-1.571,5.865,5.865,0,0,1-1.433-4.059,6.156,6.156,0,0,1,1.45-4.059,4.956,4.956,0,0,1,3.567-1.559,4.149,4.149,0,0,1,3.513,1.738l3.921-3.192s-2-3.317-7.026-3.317a10.805,10.805,0,0,0-7.638,2.8,10.335,10.335,0,0,0-3.034,7.584A10.181,10.181,0,0,0,92.378,483a10.825,10.825,0,0,0,7.634,2.821,8.527,8.527,0,0,0,7.48-3.842l-4.221-3.163A4.162,4.162,0,0,1,99.479,481.043Z" transform="translate(-89.361 -465.025)" />
              <path data-name="Path 1892" d="M116.244,465.156l-4.053,0L103.6,484.984l5.592,0,4.9-12.595,2.407,6.065-2.649,0-1.716,4.453h6.144l.864,2.091,5.715,0Z" transform="translate(-44.268 -464.622)" />
              <path data-name="Path 1893" d="M121.247,474.544a17.858,17.858,0,0,0-4.284-1.6c-1.4-.446-1.934-.838-1.934-1.646,0-.483.417-1.479,2.342-1.479a3.231,3.231,0,0,1,2.988,1.5l3.546-3.871a8.468,8.468,0,0,0-3.217-1.933,10.565,10.565,0,0,0-6.067-.071,6.35,6.35,0,0,0-4.85,6.192,4.9,4.9,0,0,0,2.525,4.488,25.138,25.138,0,0,0,4.346,1.671c.617.209,1.988.625,1.988,1.75,0,1.263-2.021,1.863-3.7,1.308a4.44,4.44,0,0,1-2.317-1.85l-3.659,4.013a9.288,9.288,0,0,0,3.434,2.221,11.638,11.638,0,0,0,3.571.6,8.449,8.449,0,0,0,5.4-1.617,6.091,6.091,0,0,0,2.354-5.063A4.787,4.787,0,0,0,121.247,474.544Z" transform="translate(-27.296 -464.976)" />
            </g>
          </g>
        </g>
      </g>
    </svg>
  );
}
export function LogoColasBlack() {
  return (
    <svg className="logo-black" xmlns="http://www.w3.org/2000/svg" width="223.995" height="72.79" viewBox="0 0 223.995 72.79" aria-hidden="true">
      <path fill="#000000" d="M202.029,494.221,111.9,459.247a9.017,9.017,0,0,0-5.651,0l-2.175.842,87.1,33.8a1.5,1.5,0,0,1,0,2.863l-86.725,33.495,2.259.879a8.977,8.977,0,0,0,5.65,0L202.029,496.5c.679-.263,1.075-.675,1.075-1.134S202.712,494.492,202.029,494.221Z" transform="translate(1.602 -458.793)" />
      <path fill="#000000" data-name="Path 1887" d="M206.23,494.068l-89.562-34.745a9.065,9.065,0,0,0-5.655,0l-2.175.842,86.537,33.578a1.5,1.5,0,0,1,0,2.863L109.73,529.688l2.259.879a9,9,0,0,0,5.646.008l88.6-34.224c.683-.267,1.075-.68,1.075-1.134S206.918,494.339,206.23,494.068Z" transform="translate(16.69 -458.552)" />
      <g data-name="Group 1790" transform="translate(0 0.441)">
        <path data-name="Path 1888" d="M263.035,493.924,174.3,459.35a8.107,8.107,0,0,0-2.913-.45h0a8.214,8.214,0,0,0-2.938.446l-88.7,34.315c-1.367.529-1.375,1.6-.008,2.129l88.737,34.578a8.172,8.172,0,0,0,2.913.446h0a8.145,8.145,0,0,0,2.938-.442l88.7-34.32C264.389,495.524,264.4,494.453,263.035,493.924Z" transform="translate(-78.714 -458.899)" />
        <g data-name="Group 1789" transform="translate(44.367 25.528)">
          <g data-name="Group 1788">
            <g data-name="Group 1787">
              <path fill="#ffffff" d="M112.4,467.846a11.767,11.767,0,0,0-15.264-.012,10.026,10.026,0,0,0-3.034,7.58,10.191,10.191,0,0,0,3.021,7.592,11.762,11.762,0,0,0,15.26.013,11.013,11.013,0,0,0,.017-15.172Zm-3.709,11.63a5.169,5.169,0,0,1-3.938,1.571,5.031,5.031,0,0,1-3.93-1.58,6.294,6.294,0,0,1,.008-8.088,5.689,5.689,0,0,1,7.863,0,5.68,5.68,0,0,1,1.475,4.046A5.758,5.758,0,0,1,108.695,479.476Z" transform="translate(-74.333 -465.012)" />
              <path fill="#ffffff" d="M105.182,465.151l-5.1,0-.007,19.84h12.82l-.006-4.773-7.706,0Z" transform="translate(-55.441 -464.638)" />
              <path fill="#ffffff" d="M99.479,481.043a4.377,4.377,0,0,1-3.438-1.571,5.865,5.865,0,0,1-1.433-4.059,6.156,6.156,0,0,1,1.45-4.059,4.956,4.956,0,0,1,3.567-1.559,4.149,4.149,0,0,1,3.513,1.738l3.921-3.192s-2-3.317-7.026-3.317a10.805,10.805,0,0,0-7.638,2.8,10.335,10.335,0,0,0-3.034,7.584A10.181,10.181,0,0,0,92.378,483a10.825,10.825,0,0,0,7.634,2.821,8.527,8.527,0,0,0,7.48-3.842l-4.221-3.163A4.162,4.162,0,0,1,99.479,481.043Z" transform="translate(-89.361 -465.025)" />
              <path fill="#ffffff" d="M116.244,465.156l-4.053,0L103.6,484.984l5.592,0,4.9-12.595,2.407,6.065-2.649,0-1.716,4.453h6.144l.864,2.091,5.715,0Z" transform="translate(-44.268 -464.622)" />
              <path fill="#ffffff" d="M121.247,474.544a17.858,17.858,0,0,0-4.284-1.6c-1.4-.446-1.934-.838-1.934-1.646,0-.483.417-1.479,2.342-1.479a3.231,3.231,0,0,1,2.988,1.5l3.546-3.871a8.468,8.468,0,0,0-3.217-1.933,10.565,10.565,0,0,0-6.067-.071,6.35,6.35,0,0,0-4.85,6.192,4.9,4.9,0,0,0,2.525,4.488,25.138,25.138,0,0,0,4.346,1.671c.617.209,1.988.625,1.988,1.75,0,1.263-2.021,1.863-3.7,1.308a4.44,4.44,0,0,1-2.317-1.85l-3.659,4.013a9.288,9.288,0,0,0,3.434,2.221,11.638,11.638,0,0,0,3.571.6,8.449,8.449,0,0,0,5.4-1.617,6.091,6.091,0,0,0,2.354-5.063A4.787,4.787,0,0,0,121.247,474.544Z" transform="translate(-27.296 -464.976)" />
            </g>
          </g>
        </g>
      </g>
    </svg>
  );
}

export function MultiLineRounded(props) {
  return (
    <svg
      width={320.069}
      height={315.015}
      viewBox="0 0 320.069 315.015"
      aria-hidden="true"
      {...props}
    >
      <path
        d="M267.354 174.156a109.506 109.506 0 10-128.253 86.8 109.508 109.508 0 00128.253-86.8"
        stroke="#fcec4f"
        fill="none"
        strokeMiterlimit={10}
        strokeWidth="2px"
      />
      <path
        d="M199.885 0l-5.994 31.081a128.5 128.5 0 0153.877 217.772c-51.767 48.382-133.247 45.624-181.633-6.148a128.217 128.217 0 01-34.01-99.49L1.078 136.37a159.8 159.8 0 0041.956 127.923c60.292 64.512 161.818 67.946 226.326 7.661A159.959 159.959 0 00199.883 0"
        fill="#a0c8d8"
      />
      <path
        d="M188.057 29.026q-2.03-.462-4.086-.856a127.563 127.563 0 00-149.4 101.114q-.873 4.527-1.413 9.036"
        stroke="#a0c8d8"
        fill="none"
        strokeMiterlimit={10}
        strokeWidth="2px"
      />
    </svg>
  );
}

export function RoundedArrowBorder(props) {
  const { color } = props;

  return (
    <svg width={32.944} height={32.114} viewBox="0 0 32.944 32.114" {...props} aria-hidden="true">
      <g
        transform="translate(0 .715) translate(0 2)"
        strokeMiterlimit={10}
        strokeWidth="1.5px"
        stroke="#ffe800"
        fill="none"
      >
        <circle cx={14.7} cy={14.7} r={14.7} stroke="none" />
        <circle cx={14.7} cy={14.7} r={13.95} />
      </g>
      <path
        d="M30.68 23.597q.114-.26.22-.526A17.435 17.435 0 0021.155.422Q20.57.189 19.978 0"
        stroke={color ? COLORS[color] : '#ffffff'}
        strokeMiterlimit={10}
        strokeWidth="1.5px"
        fill="none"
        transform="translate(0 .715)"
      />
      <path
        d="M16.663 16.455l-5.781 4.469a2.271 2.271 0 00-.881 1.794v3.455a.285.285 0 00.46.226l12.868-9.944a.286.286 0 000-.451L10.463 6.059a.286.286 0 00-.46.227v3.455a2.271 2.271 0 00.881 1.794l5.781 4.469a.284.284 0 010 .451"
        fill={color ? COLORS[color] : '#ffffff'}
        transform="translate(0 .715)"
      />
    </svg>
  );
}

export function ArrowHead(props) {
  return (
    <svg width={17.294} height={10.07} viewBox="0 0 17.294 10.07" {...props} aria-hidden="true">
      <path
        d="M7.224 9.486l.01-.011L.586 2.828A2 2 0 01.586 0l8.062 8.061 8.061-8.06a2 2 0 010 2.828l-6.647 6.646.01.01a2.027 2.027 0 01-2.848 0z"
        fill="#040405"
      />
    </svg>
  );
}

export function VerticalYellowLineShape(props) {
  return (
    <svg
      width={12.646}
      height={230.359}
      viewBox="0 0 12.646 230.359"
      aria-hidden="true"
      {...props}
    >
      <path
        d="M3.347 219.171A22.1 22.1 0 010 208.259V22.098a22.092 22.092 0 013.347-10.909 82.824 82.824 0 019.3-11.19v230.36a82.881 82.881 0 01-9.3-11.188z"
        fill="#ffed00"
      />
    </svg>
  );
}

export function HorizontalYellowLineShape(props) {
  return (
    <svg width={156.494} height={6} viewBox="0 0 156.494 6" {...props} aria-hidden="true">
      <path
        d="M151.191 4.412A10.487 10.487 0 01146.011 6H10.483a10.481 10.481 0 01-5.175-1.588A39.3 39.3 0 01-.001 0h156.492a39.323 39.323 0 01-5.3 4.412z"
        fill="#ffed00"
      />
    </svg>
  );
}

export function IconLectureTime(props) {
  return (
    <svg width={52.019} height={53.334} viewBox="0 0 52.019 53.334" {...props} aria-hidden="true">
      <path
        fill="#2c4965"
        d="M251.915 239.613V235.2a2 2 0 012-2v8.414a2 2 0 01-2-2.001z"
        transform="translate(-657.793 -1105.419) translate(509 -122.092) translate(-741.27 438.275) translate(661.686 574.348)"
      />
      <path
        fill="#2c4965"
        d="M255.648 244.23l-3.121-3.121a2 2 0 010-2.828l5.949 5.949a2 2 0 01-2.828 0z"
        transform="translate(-657.793 -1105.419) translate(509 -122.092) translate(-741.27 438.275) translate(661.686 574.348)"
      />
      <path
        fill="#2c4965"
        d="M256.127 250.879a11.812 11.812 0 01-10.883-2.795 2.2 2.2 0 012.789-.367 9.79 9.79 0 10-4.566-8.281h-2a11.789 11.789 0 1114.66 11.443z"
        transform="translate(-657.793 -1105.419) translate(509 -122.092) translate(-741.27 438.275) translate(661.686 574.348)"
      />
      <path
        fill="#2c4965"
        d="M246.817 239.436h-8.707a.7.7 0 00-.5 1.2l3.692 3.678a1.651 1.651 0 002.331 0l3.68-3.666a.709.709 0 00-.496-1.212z"
        transform="translate(-657.793 -1105.419) translate(509 -122.092) translate(-741.27 438.275) translate(661.686 574.348)"
      />
      <g fill="none" strokeMiterlimit={10} strokeWidth="2px">
        <path
          d="M188.078 13491.582a23.742 23.742 0 1031.013-12.865 23.742 23.742 0 00-31.013 12.865"
          stroke="#ffe800"
          transform="translate(-657.793 -1105.419) translate(509 -122.092) translate(-741.27 438.275) translate(704.865 -12686.602)"
        />
        <path
          d="M198.617 13525.621q.411.186.831.359a27.657 27.657 0 0036.127-14.986q.382-.925.693-1.858"
          stroke="#2c4965"
          transform="translate(-657.793 -1105.419) translate(509 -122.092) translate(-741.27 438.275) translate(704.865 -12686.602)"
        />
      </g>
    </svg>
  );
}

export function IconRoundedFacebook(props) {
  return (
    <svg width={40} height={40} viewBox="0 0 40 40" {...props} aria-hidden="true">
      <path
        d="M16.523 24.408a19.995 19.995 0 1026.119-10.835 19.995 19.995 0 00-26.119 10.835"
        fill="#3b5998"
        transform="translate(-15 -12.049)"
      />
      <path
        d="M35.784 39.405v-6.868h2.289l.355-2.646h-2.644v-1.7a1.468 1.468 0 01.237-.948 1.371 1.371 0 011.064-.355h1.418v-2.407q-.829-.081-2.053-.079a3.209 3.209 0 00-3.434 3.513v1.972h-2.289v2.646h2.289v6.872z"
        fill="#fff"
        transform="translate(-15 -12.049)"
      />
    </svg>
  );
}

export function IconRoundedTwitter(props) {
  return (
    <svg width={40} height={40} viewBox="0 0 40 40" {...props} aria-hidden="true">
      <path
        d="M16.485 27.211a19.995 19.995 0 1026.119-10.835 19.995 19.995 0 00-26.119 10.835"
        fill="#00acee"
        transform="translate(-14.962 -14.852)"
      />
      <path
        d="M41.209 32.78a8.687 8.687 0 01-1.026 4.072 8.357 8.357 0 01-2.959 3.31 8.446 8.446 0 01-4.775 1.378 8.533 8.533 0 01-4.718-1.378c.215.02.46.03.732.03a6.1 6.1 0 003.839-1.319 2.865 2.865 0 01-1.8-.6 3.062 3.062 0 01-1.068-1.504c.195.019.38.029.556.029a3.884 3.884 0 00.82-.087 3.1 3.1 0 01-1.758-1.084 2.951 2.951 0 01-.7-1.934v-.059a2.9 2.9 0 001.376.41 3.4 3.4 0 01-1-1.114 2.989 2.989 0 01.059-3.018 8.6 8.6 0 006.329 3.223 4.164 4.164 0 01-.059-.7 3.1 3.1 0 011.522-2.666 2.971 2.971 0 011.524-.41 2.922 2.922 0 011.245.264 3.463 3.463 0 011.011.7 6.224 6.224 0 001.963-.733 3.049 3.049 0 01-1.348 1.7 6.625 6.625 0 001.758-.5 6.719 6.719 0 01-1.553 1.611 1.71 1.71 0 01.03.379z"
        fill="#fff"
        transform="translate(-14.962 -14.852)"
      />
    </svg>
  );
}
export function IconRoundedX(props) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" viewBox="0 0 202.6 202.8">
      <g>
        <circle stroke="#FFFFFF" strokeWidth={0.2103} strokeMiterlimit={10} cx="101.4" cy="101.6" r="101.2" />
        <g transform="translate(52.390088,-25.058597)">
          <path id="path1009" fill="#fff" d="M2.4,78l37.2,49.7L2.2,168h8.4l32.7-35.4L69.7,168h28.6l-39.2-52.4L93.9,78h-8.4l-30.2,32.5L31.1,78H2.4z M14.9,84.1H28l58.1,77.7H72.9L14.9,84.1z" />
        </g>
      </g>
    </svg>
  );
}

export function IconRoundedLinkedin(props) {
  return (
    <svg width={39.999} height={40} viewBox="0 0 39.999 40" {...props} aria-hidden="true">
      <defs>
        <clipPath>
          <path
            d="M59.169 566.491a19.994 19.994 0 1026.118-10.835 19.995 19.995 0 00-26.118 10.835"
            transform="translate(-57.646 -554.132)"
            fill="#00acee"
          />
        </clipPath>
      </defs>
      <ellipse
        cx={19.985}
        cy={19.985}
        rx={19.985}
        ry={19.985}
        transform="translate(.029)"
        fill="#0e76a8"
      />
      <g clipPath="url(#a)">
        <g transform="translate(12.865 12.561)">
          <path
            fill="#ffffff"
            transform="translate(0 3.937)"
            d="M0 0H3.062V10.063H0z"
          />
          <path
            fill="#ffffff"
            d="M10.501 3.939c-1.751 0-2.237.574-2.626 1.313V3.939H4.812V14h3.063V8.313c0-.875 0-1.75 1.531-1.75s1.531.875 1.531 1.75v5.688H14V8.313c0-2.625-.438-4.374-3.499-4.374z"
          />
          <ellipse fill="#ffffff" className="d" cx={1.531} cy={1.531} rx={1.531} ry={1.531} />
        </g>
      </g>
    </svg>
  );
}

export function IconDeisnYellowRoundedHalf(props) {
  return (
    <svg width={36.961} height={6} viewBox="0 0 36.961 6" {...props} aria-hidden="true">
      <path
        d="M31.654 4.412A10.487 10.487 0 0126.478 6h-16a10.481 10.481 0 01-5.175-1.588A39.3 39.3 0 01-.001 0h36.963a39.323 39.323 0 01-5.308 4.412z"
        fill="#ffed00"
      />
    </svg>
  );
}

export function IconBTAlert(props) {
  return (
    <svg data-name="Calque 1" viewBox="0 0 74.68 76.81" {...props} aria-hidden="true">
      <path
        d="M2.67 21.64a35 35 0 1045.73-19 35 35 0 00-45.73 19"
        fill="#fff"
      />
      <path
        className="outer_line"
        d="M18.21 72.17c.4.19.81.36 1.23.53a40.77 40.77 0 0053.27-22.1c.38-.91.72-1.82 1-2.74"
        fill="none"
        stroke="#000"
        strokeMiterlimit={10}
        strokeWidth="2px"
      />
      <path d="M46.52 33A12.44 12.44 0 0043 26.66a15.13 15.13 0 00-1.45-1.2l-.16.23a1.78 1.78 0 00.43 2.19 10.71 10.71 0 013 5.48 1.76 1.76 0 001.62 1.53h.28a13.12 13.12 0 00-.2-1.89zM25.18 33.36a10.7 10.7 0 013-5.48 1.77 1.77 0 00.44-2.19l-.16-.23a11.84 11.84 0 00-1.46 1.2A12.37 12.37 0 0023.53 33a13.12 13.12 0 00-.25 1.87h.28a1.77 1.77 0 001.62-1.53zM50.75 33.69a17.16 17.16 0 00-1.9-5.69 16.77 16.77 0 00-3.77-4.61c-.39-.34-.8-.64-1.2-1l-.17.23a1.53 1.53 0 00.27 2 15 15 0 015.11 9.24 1.53 1.53 0 001.55 1.29h.28c-.06-.44-.09-.95-.17-1.46zM21 33.94a15 15 0 015.11-9.24 1.52 1.52 0 00.27-2l-.16-.23c-.41.31-.82.61-1.2 1a16.77 16.77 0 00-3.8 4.53 16.93 16.93 0 00-1.9 5.65c-.08.51-.12 1-.16 1.53h.28A1.53 1.53 0 0021 33.94zM41.7 39.88v-4.32a6.85 6.85 0 00-4.26-6.72 2.42 2.42 0 00-4.84 0 6.83 6.83 0 00-4.26 6.72v4.32l-1.6 1.6a1 1 0 00.71 1.71h15.14a1 1 0 001-1 1 1 0 00-.29-.7zM35 47.56a2.18 2.18 0 002-1.35 2.17 2.17 0 00.16-.87h-4.37A2.24 2.24 0 0035 47.56z" />
    </svg>
  );
}

export function IconBTDocument(props) {
  return (
    <svg data-name="Calque 1" viewBox="0 0 74.52 76.23" {...props} aria-hidden="true">
      <path
        d="M2.67 21.64a35 35 0 1045.73-19 35 35 0 00-45.73 19"
        fill="#fff"
      />
      <path
        className="outer_line"
        d="M18.05 71.6l1.22.53A40.8 40.8 0 0072.55 50c.37-.91.71-1.83 1-2.74"
        fill="none"
        stroke="#000"
        strokeMiterlimit={10}
        strokeWidth="2px"
      />
      <path d="M36.87 30.49h7a2 2 0 012 2h-11a2 2 0 012-2zM36.87 34.49h7a2 2 0 012 2h-11a2 2 0 012-2zM36.87 38.49h7a2 2 0 012 2h-11a2 2 0 012-2z" />
      <path d="M45.87 25.49a2 2 0 012 2v15.1a2 2 0 01-2 2H25.15a2 2 0 01-2-2v-15.1a2 2 0 012-2h20.72m0-2H25.15a4 4 0 00-4 4v15.1a4 4 0 004 4h20.72a4 4 0 004-4v-15.1a4 4 0 00-4-4z" />
      <rect x={25.03} y={27.49} width={8} height={15.73} rx={1.67} />
    </svg>
  );
}

export function RoundedCircle(props) {
  const { color } = props;
  return (
    <svg
      data-name="Calque 1"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 75.68 77.81"
      {...props}
      aria-hidden="true"
    >
      <path
        d="M72.02 55.17a35 35 0 10-45.74 19h0a35 35 0 0045.74-19"
        strokeMiterlimit={10}
        fill="none"
        stroke={color ? COLORS[color] : COLORS.color_dark_bleu}
        strokeWidth="2px"
      />
      <path
        d="M56.47 4.64c-.4-.19-.81-.36-1.22-.53a40.78 40.78 0 00-53.3 22.1c-.35.91-.69 1.79-1 2.79"
        fill="none"
        stroke={color ? COLORS[color] : COLORS.color_dark_bleu}
        strokeWidth="2px"
      />
    </svg>
  );
}
export function RoundedHalfCircle(props) {
  const { color } = props;
  return (
    <svg
      data-name="Calque 1"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 75.68 77.81"
      {...props}
      aria-hidden="true"
    >
      <path
        d="M56.47 4.64c-.4-.19-.81-.36-1.22-.53a40.78 40.78 0 00-53.3 22.1c-.35.91-.69 1.79-1 2.79"
        fill="none"
        stroke={color ? COLORS[color] : COLORS.color_dark_bleu}
        strokeWidth="2px"
      />
    </svg>
  );
}

export function ShapeYellowArrowBanner(props) {
  return (
    <svg data-name="Calque 1" viewBox="0 0 724.9 181.03" {...props} aria-hidden="true">
      <path
        d="M297.54 164.22a37.74 37.74 0 01-13.5 1.93 36.8 36.8 0 01-13.2-2L0 58.79l4.23 8.54C5.65 70.18 7.88 74.7 11 77.55a22.2 22.2 0 008.24 4.76L265.44 178a51.94 51.94 0 0018.56 3h.88a51.5 51.5 0 0018-2.94L705.66 23.51a21.93 21.93 0 008.24-4.76c3.12-2.84 5.35-7.36 6.77-10.21L724.9 0z"
        fill="#ffe800"
      />
    </svg>
  );
}

export function ShapeYellowArrowBannerMobile(props) {
  return (
    <svg
      data-name="Calque 1"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 533.48 100.45"
      aria-hidden="true"
      {...props}
    >
      <defs>
        <clipPath transform="translate(-.29 -1.91)">
          <path
            d="M280.54 88.22A42.89 42.89 0 01267 89.9a41.91 41.91 0 01-13.2-1.7L-17-3.59l4.23 7.43c1.42 2.49 3.65 6.43 6.77 8.9a23.13 23.13 0 008.24 4.15l246.2 83.36a58.94 58.94 0 0018.56 2.59h.88a58.28 58.28 0 0018-2.56L688.66-34.31a23.13 23.13 0 008.24-4.15c3.12-2.47 5.35-6.41 6.77-8.89l4.23-7.44z"
            fill="none"
          />
        </clipPath>
      </defs>
      <g clipPath="url(#a)">
        <path fill="#fe0" d="M0 0H533.48V100.45H0z" />
      </g>
    </svg>
  );
}

export function ShapeYellowArrowBannerWide(props) {
  return (
    <svg data-name="Calque 1" viewBox="0 0 826.34 181.03" {...props} aria-hidden="true">
      <path
        d="M339.17 164.22a48.54 48.54 0 01-15.38 1.94 47.66 47.66 0 01-15.05-2L0 58.79l4.83 8.54c1.61 2.86 4.17 7.38 7.71 10.22a26.14 26.14 0 009.39 4.76L302.59 178a66.48 66.48 0 0021.17 3h1a65.92 65.92 0 0020.52-2.94L804.41 23.52a26.3 26.3 0 009.39-4.76c3.55-2.85 6.1-7.37 7.72-10.22L826.34 0z"
        fill="#ffe800"
      />
    </svg>
  );
}

export function MaqsueBannerHome(props) {
  return (
    <svg
      data-name="Calque 1"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 1365.15 280.31"
      aria-hidden="true"
      {...props}
    >
      <path
        fill="#fff"
        d="M0.31 280.31L0 0 682.16 265.97 1365 1.98 1365.15 279.74 0.31 280.31z"
      />
      <path
        d="M692.8 258.54a37.18 37.18 0 01-13.24 1.88 36.54 36.54 0 01-12.95-1.9L401 156l4.15 8.32c1.38 2.77 3.58 7.17 6.64 9.94a21.73 21.73 0 008.07 4.64L661.32 272a51.24 51.24 0 0018.21 2.88h.87a50.69 50.69 0 0017.65-2.88l395.1-149.81a21.58 21.58 0 008.07-4.63c3.06-2.77 5.26-7.17 6.64-10l4.15-8.31z"
        fill="#ffe800"
      />
    </svg>
  );
}

export function MaqsueBannerPage(props) {
  return (
    <svg
      data-name="Calque 1"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 1366.74 347.27"
      aria-hidden="true"
      {...props}
    >
      <g data-name="MASQUE IMAGE">
        <path
          d="M.25 348H1367V140.71l-10.79 4.21-71.21 27.71L909 319c-11.5 4.45-25.41 12.44-40.65 12.26-15.35.22-32.35-7.71-43.99-12.26L.25.73z"
          transform="translate(-.25 -.73)"
          fill="#fff"
        />
        <path
          d="M875 328.42a46.15 46.15 0 01-26.18 0L583.14 225.89l4.15 8.31c1.38 2.78 3.58 7.18 6.64 10a21.58 21.58 0 008.07 4.63l241.47 93.1a51.29 51.29 0 0018.21 2.89h.87a50.46 50.46 0 0017.65-2.87l395.1-149.81a21.58 21.58 0 008.07-4.63c3.06-2.77 5.26-7.17 6.64-10l4.16-8.31z"
          transform="translate(-.25 -.73)"
          fill="#ffe800"
        />
      </g>
    </svg>
  );
}

export function MaqsueBannerPageMobile(props) {
  return (
    <svg
      data-name="Calque 1"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 414 91"
      aria-hidden="true"
      {...props}
    >
      <defs>
        <clipPath>
          <path fill="none" d="M0 0H414V91H0z" />
        </clipPath>
      </defs>
      <g clipPath="url(#aazeazsffza)">
        <path
          fill="#fff"
          d="M0.04 8.33L205.88 86.06 413.9 8.6 414 91 0 91 0.04 8.33z"
        />
        <path
          d="M219 73.71a37.75 37.75 0 01-13.5 1.94 37 37 0 01-13.2-2L-78.5-31.72l4.23 8.54c1.42 2.86 3.65 7.38 6.77 10.22a22.07 22.07 0 008.24 4.76l246.2 95.73a51.72 51.72 0 0018.57 3h.88a51.27 51.27 0 0018-2.94L627.16-67a22.2 22.2 0 008.24-4.76c3.12-2.84 5.35-7.37 6.77-10.22l4.23-8.54z"
          fill="#ffe800"
        />
      </g>
    </svg>
  );
}
export function MaqsueBannerPageTablet(props) {
  return (
    <svg
      data-name="Calque 1"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 548.49 118.44"
      aria-hidden="true"
      {...props}
    >
      <defs>
        <clipPath>
          <path fill="none" d="M-0.37 -3.71H548.67V118.49000000000001H-0.37z" />
        </clipPath>
      </defs>
      <g clipPath="url(#a)">
        <path
          fill="#fff"
          d="M-15.55 8.01L271.57 112.89 561.7 8.38 561.85 119.55 -15.6 119.55 -15.55 8.01z"
        />
        <path
          d="M287.24 101.19a37.59 37.59 0 01-13.51 1.94 37.18 37.18 0 01-13.23-1.95L-10.8-4.28l4.24 8.55C-5.14 7.12-2.9 11.64.22 14.49a22.11 22.11 0 008.25 4.76L255.1 115a52.07 52.07 0 0018.6 3h.88a51.44 51.44 0 0018-2.94L696.06-39.57a22 22 0 008.25-4.76c3.13-2.84 5.37-7.37 6.78-10.22l4.24-8.55z"
          fill="#ffe800"
        />
      </g>
    </svg>
  );
}

export function MasqueBannerPage(props) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="1366.004" height="530.001" viewBox="0 0 1366.004 530.001" {...props}>
      <g id="Groupe_4330" data-name="Groupe 4330" transform="translate(16207 12592)">
        <path id="Exclusion_4" data-name="Exclusion 4" d="M1366,530H0V0L0,328.776,445.959,502.55c2.55.988,5.194,2.14,7.993,3.359l.006,0c9.583,4.176,20.444,8.909,32.1,8.909.168,0,.336,0,.5,0,.215,0,.44.006.69.006a68.251,68.251,0,0,0,19.687-3.391c6.493-1.972,12.721-4.49,18.215-6.711,1.868-.755,3.63-1.468,5.291-2.113L1366,179.315h0V0l0,179.313h0V530Z" transform="translate(-16207 -12592)" fill="#fff" />
        <path id="Tracé_7688" data-name="Tracé 7688" d="M886.692,698.611a37.659,37.659,0,0,1-13.493,1.936,37.016,37.016,0,0,1-13.2-1.954L589.157,593.183l4.233,8.54c1.413,2.853,3.65,7.375,6.768,10.217a22.018,22.018,0,0,0,8.235,4.76L854.6,712.432a51.883,51.883,0,0,0,18.569,2.968q.441,0,.883,0a51.255,51.255,0,0,0,18-2.942l402.77-154.552a22.016,22.016,0,0,0,8.234-4.76c3.118-2.842,5.355-7.365,6.77-10.217l4.233-8.54Z" transform="translate(-16594.156 -12777.899)" fill="#ffe800" />
      </g>
    </svg>
  );
}

export function MasqueBannerPageMobile(props) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="415.278" height="519" viewBox="0 0 415.278 519" {...props}>
      <g id="Groupe_4331" data-name="Groupe 4331" transform="translate(12737.501 12592.5)">
        <path id="Exclusion_5" data-name="Exclusion 5" d="M414,518H0V444.447L118.956,490.8c2.552.988,5.2,2.141,8,3.361,9.585,4.176,20.449,8.909,32.1,8.909l.506,0c.23,0,.46.005.681.005a68.224,68.224,0,0,0,19.667-3.386c6.487-1.969,12.712-4.484,18.2-6.7,1.88-.759,3.654-1.476,5.327-2.126L414,409.389V518ZM414,0H0L414,0l0,0Z" transform="translate(-12737 -12592)" fill="#fff" stroke="rgba(0,0,0,0)" strokeMiterlimit="10" strokeWidth="1" />
        <path id="Tracé_7689" data-name="Tracé 7689" d="M886.692,698.611a37.659,37.659,0,0,1-13.493,1.936,37.016,37.016,0,0,1-13.2-1.954L720.029,644.565l4.233,8.54c1.413,2.853,3.65,7.375,6.768,10.217a22.018,22.018,0,0,0,8.235,4.76L854.6,712.432a51.883,51.883,0,0,0,18.569,2.968q.441,0,.883,0a51.255,51.255,0,0,0,18-2.942l198.79-75.1a22.016,22.016,0,0,0,8.234-4.76c3.118-2.842,5.355-7.365,6.77-10.217l4.233-8.54Z" transform="translate(-13451.156 -12789.652)" fill="#ffe800" />
      </g>
    </svg>
  );
}
export function MasqueBannerPageTablet(props) {
  return (
    <svg
      data-name="Calque 1"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 548.49 118.44"
      aria-hidden="true"
      {...props}
    >
      <defs>
        <clipPath>
          <path fill="none" d="M-0.37 -3.71H548.67V118.49000000000001H-0.37z" />
        </clipPath>
      </defs>
      <g clipPath="url(#a)">
        <path
          fill="#fff"
          d="M-15.55 8.01L271.57 112.89 561.7 8.38 561.85 119.55 -15.6 119.55 -15.55 8.01z"
        />
        <path
          d="M287.24 101.19a37.59 37.59 0 01-13.51 1.94 37.18 37.18 0 01-13.23-1.95L-10.8-4.28l4.24 8.55C-5.14 7.12-2.9 11.64.22 14.49a22.11 22.11 0 008.25 4.76L255.1 115a52.07 52.07 0 0018.6 3h.88a51.44 51.44 0 0018-2.94L696.06-39.57a22 22 0 008.25-4.76c3.13-2.84 5.37-7.37 6.78-10.22l4.24-8.55z"
          fill="#ffe800"
        />
      </g>
    </svg>
  );
}

export function MasqueBannerPageReverse(props) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="1366.03" height="447.524" viewBox="0 0 1366.03 447.524" {...props}>
      <g id="Groupe_4328" data-name="Groupe 4328" transform="translate(0.081 -364)">
        <g id="Groupe_1903" data-name="Groupe 1903" transform="translate(-1041.916 -75.097)">
          <g id="Groupe_1790" data-name="Groupe 1790" transform="translate(78.714 459.097)">
            <path id="Tracé_1888" data-name="Tracé 1888" d="M2407.865,835.213l-948.873-369.8c-11.554-4.512-29.09-12.909-44.254-12.729h-2.208c-15.345-.179-26.41,8.156-38.023,12.672l-332.662,128.87c0,51.239-.01,290.9-.01,290.9l1366.03,1.3Z" transform="translate(-78.714 -458.899)" fill="#fff" />
          </g>
        </g>
        <path id="Tracé_1958" data-name="Tracé 1958" d="M886.692,551.187a37.659,37.659,0,0,0-13.493-1.936,37.016,37.016,0,0,0-13.2,1.954L589.157,656.615l4.233-8.54c1.413-2.853,3.65-7.375,6.768-10.217a22.018,22.018,0,0,1,8.235-4.76L854.6,537.365a51.883,51.883,0,0,1,18.569-2.968q.441,0,.883,0a51.255,51.255,0,0,1,18,2.942l402.77,154.552a22.016,22.016,0,0,1,8.234,4.76c3.118,2.842,5.355,7.365,6.77,10.217l4.233,8.54Z" transform="translate(-501.156 -170.393)" fill="#ffed00" />
      </g>
    </svg>
  );
}

export function MasqueBannerPageReverseMobile(props) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="413.6" height="128.148" viewBox="0 0 413.6 128.148" {...props}>
      <g id="Groupe_4327" data-name="Groupe 4327" transform="translate(-0.244 -364)">
        <g id="Groupe_1790" data-name="Groupe 1790" transform="translate(-1209.202 384)">
          <path id="Tracé_1888" data-name="Tracé 1888" d="M1701.759,560.022l-242.767-94.613c-11.554-4.512-29.09-12.909-44.254-12.729h-2.208c-15.345-.179-26.41,8.156-38.023,12.672l-86.347,33.45c0,19.663,0,68.154,0,68.154l413.6.093Z" transform="translate(-78.714 -458.899)" fill="#fff" />
        </g>
        <path id="Tracé_1958" data-name="Tracé 1958" d="M886.692,551.187a37.659,37.659,0,0,0-13.493-1.936,37.016,37.016,0,0,0-13.2,1.954L758.2,593.372l4.233-8.54c1.413-2.853,3.65-7.375,6.768-10.217a22.018,22.018,0,0,1,8.235-4.76L854.6,537.365a51.883,51.883,0,0,1,18.569-2.968q.441,0,.883,0a51.255,51.255,0,0,1,18,2.942l234.1,92.158a22.016,22.016,0,0,1,8.234,4.76c3.118,2.842,5.355,7.365,6.77,10.217l4.233,8.54Z" transform="translate(-747.156 -170.393)" fill="#ffed00" />
      </g>
    </svg>
  );
}

export function BTNPlay(props) {
  const { color } = props;
  return (
    <svg x="0px" y="0px" viewBox="0 0 74.7 76.8" xmlSpace="preserve" {...props} aria-hidden="true">
      <path
        fill={color ? COLORS[color] : COLORS.color_yellow}
        className="circle"
        d="M2.7 21.6c-7.4 17.9 1.1 38.3 19 45.7s38.3-1.1 45.7-19c7.4-17.9-1.1-38.3-19-45.7-17.9-7.3-38.3 1.2-45.7 19"
        transform="translate(-869.269 -771.816) translate(869.27 771.82)"
      />
      <path
        d="M887.5 844c.4.2.8.4 1.2.5 20.8 8.6 44.7-1.3 53.3-22.1.4-.9.7-1.8 1-2.7"
        fill="none"
        stroke="#000"
        strokeWidth={2}
        transform="translate(-869.269 -771.816)"
      />
      <path
        className="icon"
        d="M913.2 805.4l-11.8-7.2c-.8-.5-1.9-.3-2.4.6-.2.3-.3.6-.3.9v14.5c0 1 .8 1.8 1.8 1.8.3 0 .7-.1.9-.3l11.8-7.2c.8-.5 1.1-1.6.6-2.4-.2-.3-.4-.5-.6-.7z"
        fill="#000"
        transform="translate(-869.269 -771.816)"
      />
    </svg>
  );
}

export function BTNPlayTransparent(props) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="142.04" height="142.04" viewBox="0 0 142.04 142.04" {...props}>
      <defs>
        <filter id="Exclusion_1" x="0" y="0" width="142.04" height="142.04" filterUnits="userSpaceOnUse">
          <feOffset dy="6" input="SourceAlpha" />
          <feGaussianBlur stdDeviation="12" result="blur" />
          <feFlood floodColor="#2c4965" floodOpacity="0.129" />
          <feComposite operator="in" in2="blur" />
          <feComposite in="SourceGraphic" />
        </filter>
      </defs>
      <g id="BT_Play" data-name="BT/Play" transform="translate(36 30)">
        <g transform="matrix(1, 0, 0, 1, -36, -30)" filter="url(#Exclusion_1)">
          <path id="Exclusion_1-2" data-name="Exclusion 1" d="M12272.876,12204.222h0a35.019,35.019,0,0,1-19.219-64.279,35.127,35.127,0,0,1,19.246-5.761,35.021,35.021,0,0,1,19.219,64.28,35.13,35.13,0,0,1-19.243,5.76Zm-3.792-43.925a1.768,1.768,0,0,0-1.767,1.767v14.465a1.772,1.772,0,0,0,2.694,1.508l11.761-7.234a1.77,1.77,0,0,0,0-3.013l-11.761-7.23A1.789,1.789,0,0,0,12269.084,12160.3Z" transform="translate(-12201.87 -12104.18)" fill="#ffed00" />
        </g>
        <path id="Tracé_2127" data-name="Tracé 2127" d="M75.853,626.311q.606.275,1.225.53a40.785,40.785,0,0,0,53.276-22.1q.564-1.364,1.022-2.74" transform="translate(-57.647 -554.133)" fill="none" stroke="#fff" strokeWidth="2" />
      </g>
    </svg>
  );
}

export function BTNPause(props) {
  return (
    <svg
      x="0px"
      y="0px"
      viewBox="0 0 74.7 76.8"
      xmlSpace="preserve"
      {...props}
      aria-hidden="true"
    >
      <path
        d="M2.7 21.6c-7.4 17.9 1.1 38.3 19 45.7s38.3-1.1 45.7-19c7.4-17.9-1.1-38.3-19-45.7-17.9-7.3-38.3 1.2-45.7 19"
        fill="#ffed00"
        transform="translate(-842.269 -747.816) translate(842.27 747.82)"
      />
      <path
        d="M860.5 820c.4.2.8.4 1.2.5 20.8 8.6 44.7-1.3 53.3-22.1.4-.9.7-1.8 1-2.7"
        fill="none"
        stroke="#000"
        strokeWidth={2}
        transform="translate(-842.269 -747.816)"
      />
      <path
        fill="#040405"
        d="M-5.8 720.5v12.4c0 1.7 1.4 3.1 3.1 3.1h.8v-18.5h-.8c-1.7 0-3.1 1.3-3.1 3zM6.3 717.5h-.8V736h.8c1.7 0 3.1-1.4 3.1-3.1v-12.4c-.1-1.7-1.4-3-3.1-3z"
        transform="translate(-842.269 -747.816) translate(875.794 57.083)"
      />
    </svg>
  );
}

export function BTNAudio(props) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      x="0px"
      y="0px"
      viewBox="0 0 74.7 76.8"
      xmlSpace="preserve"
      {...props}
      aria-hidden="true"
    >
      <path
        className="path_1"
        d="M2.7 21.6c-7.4 17.9 1.1 38.3 19 45.7s38.3-1.1 45.7-19c7.4-17.9-1.1-38.3-19-45.7-17.9-7.3-38.3 1.2-45.7 19"
        fill="#ffed00"
        transform="translate(-842.269 -747.816) translate(842.27 747.82)"
      />
      <path
        className="path_2"
        d="M860.5 820c.4.2.8.4 1.2.5 20.8 8.6 44.7-1.3 53.3-22.1.4-.9.7-1.8 1-2.7"
        fill="none"
        stroke="#fff"
        strokeWidth={2}
        transform="translate(-842.269 -747.816)"
      />
      <path
        className="path_3"
        d="M68.9 591.7c-.6-.3-1.3-.1-1.8.4l-4.5 4.5h-4.7c-.9 0-1.7.7-1.7 1.7v4.7c0 .9.7 1.7 1.7 1.7h4.7l4.5 4.5c.7.7 1.7.7 2.4 0 .3-.3.5-.7.5-1.2v-14.7c-.1-.7-.5-1.3-1.1-1.6zM78 605h.2c2.7-.9 4.2-3.7 3.3-6.4-.5-1.7-1.9-2.9-3.5-3.4-1.3-.3-2.6.5-2.9 1.7l-.1.5 2.3.6c1.2.4 1.8 1.6 1.4 2.7-.2.7-.8 1.3-1.5 1.5l-2.1.6.1.5c.4 1.2 1.6 2 2.8 1.7z"
        transform="translate(-842.269 -747.816) translate(817.232 245.892) translate(-12.322 -62.935)"
      />
      <path
        className="path_4"
        d="M89.3 600.1c0-5.9-3.9-11.1-9.6-12.8h-.2c-1.2-.2-2.4.5-2.7 1.7l-.1.5 2.1.6c5.5 1.5 8.8 7.2 7.3 12.8-1 3.5-3.7 6.3-7.3 7.3l-2.3.6.1.5c.3 1.2 1.6 2 2.9 1.7h.1c5.7-1.7 9.7-6.9 9.7-12.9z"
        transform="translate(-842.269 -747.816) translate(817.232 245.892) translate(-12.322 -62.935)"
      />
    </svg>
  );
}

export function IconPreview(props) {
  return (
    <svg x="0px" y="0px" viewBox="0 0 74.7 76.8" xmlSpace="preserve" {...props} aria-hidden="true">
      <path
        fill="#fff"
        className="circle"
        d="M2.7 21.6c-7.4 17.9 1.1 38.3 19 45.7s38.3-1.1 45.7-19c7.4-17.9-1.1-38.3-19-45.7-17.9-7.3-38.3 1.2-45.7 19"
        transform="translate(-127.999 -1210.092) translate(-741.27 438.275) translate(869.27 771.82)"
      />
      <path
        d="M887.5 844c.4.2.8.4 1.2.5 20.8 8.6 44.7-1.3 53.3-22.1.4-.9.7-1.8 1-2.7"
        fill="none"
        stroke="#000"
        strokeWidth={2}
        strokeMiterlimit={10}
        transform="translate(-127.999 -1210.092) translate(-741.27 438.275)"
      />
      <path
        d="M904.3 799.8c-4.9 0-9.2 3-11 7.5 2.4 6.1 9.2 9.1 15.3 6.7 3.1-1.2 5.5-3.6 6.7-6.7-1.8-4.6-6.2-7.5-11-7.5zm0 12.5c-2.8 0-5-2.2-5-5s2.2-5 5-5 5 2.2 5 5c0 2.7-2.3 5-5 5zm0-8c-1.7 0-3 1.3-3 3s1.3 3 3 3 3-1.3 3-3-1.4-3-3-3z"
        fill="#000"
        className="icon"
        transform="translate(-127.999 -1210.092) translate(-741.27 438.275)"
      />
    </svg>
  );
}

export function IconDownload(props) {
  return (
    <svg
      x="0px"
      y="0px"
      viewBox="0 0 74.7 76.8"
      xmlSpace="preserve"
      {...props}
      aria-hidden="true"
    >
      <path
        fill="#fff"
        className="circle"
        d="M2.7 21.6c-7.4 17.9 1.1 38.3 19 45.7s38.3-1.1 45.7-19c7.4-17.9-1.1-38.3-19-45.7-17.9-7.3-38.3 1.2-45.7 19"
        transform="translate(-127.999 -1210.092) translate(-741.27 438.275) translate(869.27 771.82)"
      />
      <path
        d="M887.5 844c.4.2.8.4 1.2.5 20.8 8.6 44.7-1.3 53.3-22.1.4-.9.7-1.8 1-2.7"
        fill="none"
        stroke="#000"
        strokeWidth={2}
        strokeMiterlimit={10}
        transform="translate(-127.999 -1210.092) translate(-741.27 438.275)"
      />
      <path
        className="icon"
        fil="#000"
        d="M85.3 481.3c.9.9 2.2.9 3.1 0l7.3-7.3c.9-.9.9-2.2 0-3.1l-7.5 7.5V462c0-1.2-1-2.2-2.2-2.2h-.4v18.7l-7.5-7.5c-.9.9-.9 2.2 0 3.1l7.2 7.2zM77 485.1v.4h2v-2.6c-1.2.1-2 1.1-2 2.2zM94.5 482.9H79v2.6h17.5v-.4c.1-1.1-.8-2.1-2-2.2z"
        transform="translate(-127.999 -1210.092) translate(-741.27 438.275) translate(817.532 332.621)"
      />
    </svg>
  );
}

export function IconDownloadZip(props) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      x="0px"
      y="0px"
      viewBox="0 0 74.7 76.8"
      xmlSpace="preserve"
      {...props}
    >
      <path
        d="M2.7 21.6c-7.4 17.9 1.1 38.3 19 45.7s38.3-1.1 45.7-19-1.1-38.3-19-45.7c-17.9-7.3-38.3 1.2-45.7 19"
        fill="#fff"
        className="circle"
      />
      <path
        d="M18.2 72.2c.4.2.8.4 1.2.5 20.8 8.6 44.7-1.3 53.3-22.1.4-.9.7-1.8 1-2.7"
        fill="none"
        stroke="#000"
        strokeWidth={2}
        strokeMiterlimit={10}
      />
      <path className="icon" d="M36.6 18c0 .4.3.7.7.7h9.8v30h-9.8c-.4 0-.7.3-.7.7 0 .4.3.7.7.7h10.5c.4 0 .7-.3.7-.7V18c0-.4-.3-.7-.7-.7H37.3c-.4 0-.7.3-.7.7z" />
      <path className="icon" d="M44.9 34.6s0-.1 0 0c.2-.2.2-.3.2-.4V34c0-.1-.1-.2-.2-.2l-8.9-9c-.2-.2-.6-.2-.8 0-.2.2-.2.6 0 .8l7.9 7.9H22.3c-.3 0-.6.2-.6.6 0 .3.2.6.6.6h20.9l-8 8c-.2.2-.2.6 0 .8.2.2.6.2.8 0l8.9-8.9z" />
    </svg>
  );
}

export function HorizontalYellowLineShape2(props) {
  const fill = (props.fill) ? props.fill : '#ffed00';
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="64.49" height="4" viewBox="0 0 64.49 4" {...props} aria-hidden="true"><path fill={fill} d="M-66.461,1.059A6.991,6.991,0,0,1-63.011,0H-12.5a6.988,6.988,0,0,1,3.45,1.059A26.2,26.2,0,0,1-5.509,4H-70A26.215,26.215,0,0,1-66.461,1.059Z" transform="translate(-5.51 4) rotate(180)" /></svg>
  );
}

export function HorizontalYellowLineShape3(props) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="48.24" height="109.56" viewBox="0 0 76.612 169.447" {...props} aria-hidden="true"><g data-name="Group 2902" transform="translate(-328.232 -566.782)"><path data-name="Path 1896" d="M213.4,267.147a22.111,22.111,0,0,0,3.347-10.908V130.987a22.116,22.116,0,0,0-3.347-10.908,82.818,82.818,0,0,0-9.3-11.19V278.336A82.818,82.818,0,0,0,213.4,267.147Z" transform="translate(124.127 457.893)" fill="#ffed00" /><line data-name="Line 765" x2="67.443" transform="translate(335.402 651.506)" fill="none" stroke="#ffed00" strokeLinecap="round" strokeLinejoin="round" strokeWidth="4" /></g></svg>
  );
}

export function Notification(props) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="74.643" height="76.457" viewBox="0 0 74.643 76.457" aria-hidden="true">
      <g data-name="Group 2313" transform="translate(0.602 0.602)">
        <g data-name="Group 1953">
          <g data-name="Group 1904" transform="translate(0 0)">
            <path data-name="Path 2126" d="M60.313,575.772A35.011,35.011,0,1,0,106.047,556.8a35.011,35.011,0,0,0-45.734,18.972" transform="translate(-57.646 -554.133)" fill="#fff" stroke="#ffe800" strokeMiterlimit="10" strokeWidth="1" />
            <path data-name="Path 2127" d="M75.853,626.311q.606.275,1.225.53a40.785,40.785,0,0,0,53.276-22.1q.564-1.364,1.022-2.74" transform="translate(-57.81 -554.713)" fill="none" stroke="#000" strokeMiterlimit="10" strokeWidth="1" />
            <path d="M8.868,4.447,7.106,2.685A12.844,12.844,0,0,0,2.03,12.356H4.494A10.405,10.405,0,0,1,8.868,4.447Zm15.265,7.91H26.6a12.922,12.922,0,0,0-5.076-9.671L19.771,4.447A10.466,10.466,0,0,1,24.132,12.356Zm-2.427.616c0-3.782-2.021-6.949-5.544-7.786V4.348a1.848,1.848,0,0,0-3.7,0v.838c-3.536.838-5.544,3.992-5.544,7.786v6.16L4.457,21.6v1.232H24.169V21.6l-2.464-2.464ZM14.313,26.524a2.158,2.158,0,0,0,.493-.049,2.5,2.5,0,0,0,1.774-1.454,2.474,2.474,0,0,0,.185-.961H11.837a2.482,2.482,0,0,0,2.476,2.464Z" transform="translate(20.47 20)" />
          </g>
        </g>
      </g>
    </svg>
  );
}

export function Feed(props) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="74.643" height="76.457" viewBox="0 0 74.643 76.457" aria-hidden="true">
      <g data-name="Group 2314" transform="translate(0.602 0.602)">
        <g data-name="Group 1953">
          <g data-name="Group 1904" transform="translate(0 0)">
            <path data-name="Path 2126" d="M60.313,575.772A35.011,35.011,0,1,0,106.047,556.8a35.011,35.011,0,0,0-45.734,18.972" transform="translate(-57.646 -554.133)" fill="#fff" stroke="#ffe800" strokeMiterlimit="10" strokeWidth="1" />
            <path data-name="Path 2127" d="M75.853,626.311q.606.275,1.225.53a40.785,40.785,0,0,0,53.276-22.1q.564-1.364,1.022-2.74" transform="translate(-57.81 -554.713)" fill="none" stroke="#000" strokeMiterlimit="10" strokeWidth="1" />
            <path id="ic_chrome_reader_mode_24px" d="M14.48,12.987h7.863v1.685H14.48Zm0-2.808h7.863v1.685H14.48Zm0,5.617h7.863V17.48H14.48ZM23.467,4H3.247A2.253,2.253,0,0,0,1,6.247v14.6A2.253,2.253,0,0,0,3.247,23.1h20.22a2.253,2.253,0,0,0,2.247-2.247V6.247A2.253,2.253,0,0,0,23.467,4Zm0,16.85H13.357V6.247h10.11Z" transform="translate(21.502 21.499)" />
          </g>
        </g>
      </g>
    </svg>
  );
}

export function ShapeRightAlignedTwoLines(props) {
  return (
    <svg
      width={325.057}
      height={199.549}
      viewBox="0 0 325.057 199.549"
      aria-hidden="true"
      {...props}
    >
      <defs>
        <clipPath>
          <path
            d="M1167.566 512.238L842.51 638.649v-73.138L1167.566 439.1z"
            transform="translate(-842.51 -439.1)"
            fill="none"
          />
        </clipPath>
      </defs>
      <g>
        <path
          fill="#ffe800"
          d="M355.203 3.198l-8.24-3.2L0 134.334l8.221 3.2a32.807 32.807 0 0020.566.023L355.208 11.5c2.477-.958 3.906-2.459 3.912-4.121s-1.42-3.196-3.917-4.181zM425.426 3.526L417.235.348 75.052 132.831l-.911.353 8.221 3.205a32.879 32.879 0 0020.567.022l322.5-124.583c2.479-.958 3.906-2.459 3.911-4.121s-1.42-3.195-3.914-4.181z"
          transform="translate(23.029 -.402)"
        />
      </g>
    </svg>
  );
}

export function RHIcon(props) {
  return (
    <svg
      data-name="Calque 1"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 74.52 76.23"
      aria-hidden="true"
      {...props}
    >
      <path
        d="M2.67 21.64a35 35 0 1045.73-19 35 35 0 00-45.73 19"
        fill="#fff"
      />
      <path
        d="M18.05 71.6l1.22.53A40.8 40.8 0 0072.55 50c.37-.91.71-1.83 1-2.74"
        fill="none"
        stroke="#000"
        strokeMiterlimit={10}
        strokeWidth="2px"
      />
      <path
        fill="#1d1d1b"
        d="M34.79 15.47h.1l3-1.17v-.07l-3-1.17h-.2l-3 1.17v.07l3 1.16z"
      />
      <path
        fill="#1d1d1b"
        d="M51.2 44.72a6 6 0 00-1.42-2A6.27 6.27 0 0047 41.29L42 40l-1.48-1.48-.19-.13v-2.04a9 9 0 003-4.18 2.1 2.1 0 00.5.09h2a2.17 2.17 0 00.94-.23 1.89 1.89 0 00.73-.64 2 2 0 00.33-1.14v-6a2.07 2.07 0 00-.33-1.13 1.82 1.82 0 00-.79-.66c-.11-.71-.33-1.93-.66-3.31a33.73 33.73 0 00-1-3.4 13.5 13.5 0 00-1.42-3.06 6.22 6.22 0 00-2.44-2A13.85 13.85 0 0037 9.44a18.1 18.1 0 00-2.2-.17 18.08 18.08 0 00-3.52.4 12.06 12.06 0 00-2.86 1 6.22 6.22 0 00-2.44 2 13.5 13.5 0 00-1.42 3.06 42.9 42.9 0 00-1.63 6.71.11.11 0 00-.06 0 1.74 1.74 0 00-.73.64 2 2 0 00-.33 1.13v6a1.89 1.89 0 001.39 1.91 2.08 2.08 0 00.6.09h2a1.69 1.69 0 00.5-.08 9.07 9.07 0 003 4.18v2.07a.8.8 0 00-.19.13L27.6 40h-.06l-5 1.26a6 6 0 00-4.54 4.4 6.12 6.12 0 00-.24 1.59v4.4a2 2 0 002 2v-6.4a4.78 4.78 0 01.45-1.81 4 4 0 011-1.29 4.18 4.18 0 011.79-.93l.76-.19v8.62a2 2 0 002 2V42.53l1.35-.34 2.75 5.51a1 1 0 001.34.45l.16-.1 2.4-1.8v6.5a1 1 0 002 0v-6.5l2.4 1.8a1 1 0 001.4-.2l.09-.15 2.76-5.51 1.35.34v11.12a2 2 0 002-2V43l.76.19a4 4 0 013.06 3 5.27 5.27 0 01.16.79v6.61a2 2 0 002-2v-4.4a6.73 6.73 0 00-.54-2.47zM39.75 26.25h-2.59a5 5 0 00-.44-.33 3.12 3.12 0 00-3.86 0 5.33 5.33 0 00-.45.33h-2.62a1.15 1.15 0 01-.72-.27 3.86 3.86 0 01-1-1.25 6.11 6.11 0 01-.27-.58l-.05-.15a1.8 1.8 0 00-1.36-1.63h-.05a5.32 5.32 0 011-1c1.22-1 3.42-2 7.47-2 4.32 0 6.53 1.19 7.7 2.24a4.49 4.49 0 01.74.83 2 2 0 00-.39.14 1.89 1.89 0 00-.73.64 2 2 0 00-.32 1.13 2.1 2.1 0 01-.3 1.18 1.94 1.94 0 01-1.06.71 4.59 4.59 0 01-.51.1h-.17zm6 4h-1.9v-.09-1.15-4.76h2zM27.62 13.81a4.26 4.26 0 011.68-1.38 11.48 11.48 0 013.54-1 15.7 15.7 0 011.94-.16 16.19 16.19 0 013.1.36 10.26 10.26 0 012.38.8A4.26 4.26 0 0142 13.81a11.8 11.8 0 011.2 2.6 32.83 32.83 0 011.09 4c-.13-.14-.26-.28-.41-.42-1.58-1.43-4.37-2.75-9-2.75-4.68 0-7.47 1.32-9 2.75q-.22.21-.42.42c.11-.51.24-1.06.39-1.63a18 18 0 011.77-4.97zm-3.83 10.44h2v4.77c0 .52 0 1-.05 1.16v.08h-1.9zm4 5V27.5a.34.34 0 00.09.08 3.06 3.06 0 001.91.67h3a1 1 0 00.7-.29 4.17 4.17 0 01.53-.41 1.66 1.66 0 01.77-.3 1.69 1.69 0 01.82.34 3 3 0 01.35.27l.1.08a1 1 0 00.71.29h3a4.75 4.75 0 002-.47l.08-.05v1.52a7 7 0 01-14 0zm7 9a9 9 0 003.51-.71v1.77l-3.52 3.53-3.53-3.53v-1.77a9 9 0 003.54.71zm-3.64 7.48L29 41.45l.79-.78 3.48 3.48zm7.28 0l-2.12-1.58 3.48-3.48.78.78z"
      />
    </svg>
  );
}

export function ArrowIconRight(props) {
  const { customCLass } = props;

  return (
    <svg className={customCLass} xmlns="http://www.w3.org/2000/svg" width="10.07" height="18" viewBox="0 0 10.07 18">
      <g
        transform="translate(10.07) rotate(90)">
        <path
          data-name="Tracé 2316"
          d="M.584,7.224l.011.01L7.242.586a2,2,0,0,1,2.828,0L2.009,8.648l8.06,8.061a2,2,0,0,1-2.828,0L.6,10.062l-.01.01a2.027,2.027,0,0,1,0-2.848Z"
          transform="translate(0.706 10.07) rotate(-90)"
          fill="#040405" />
      </g>
    </svg>
  );
}

export function LineBlackBannerHome(props) {
  const { customClass } = props;
  return (
    <svg className={customClass || 'line'} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 58 2" aria-hidden="true"><g id="Group_2902" data-name="Group 2902"><path id="Path_1896" data-name="Path 1896" fill="#000" d="M54.17.53A14.48,14.48,0,0,0,50.44,0H7.57A14.48,14.48,0,0,0,3.84.53,34,34,0,0,0,0,2H58A33.86,33.86,0,0,0,54.17.53Z" /></g></svg>
  );
}

export function PictoBannerHome(props) {
  const { customClass } = props;
  return (
    <svg className={customClass || 'graph'} xmlns="http://www.w3.org/2000/svg" width="84.296" height="72.018" viewBox="0 0 84.296 72.018" aria-hidden="true">
      <g transform="translate(1 71.018)">
        <g>
          <line x2="82.296" fill="none" stroke="#fff" strokeWidth="2" />
        </g>
      </g>
      <rect width="12.001" height="20.574" transform="translate(9.572 45.301)" fill="none" stroke="#fff" strokeWidth="2" />
      <rect width="12.001" height="24.003" transform="translate(26.717 41.872)" fill="none" stroke="#fff" strokeWidth="2" />
      <rect width="12.001" height="34.29" transform="translate(43.862 31.585)" fill="none" stroke="#fff" strokeWidth="2" />
      <rect width="12.001" height="36.004" transform="translate(61.007 29.87)" fill="none" stroke="#fff" strokeWidth="2" />
      <g transform="translate(14.615 1)">
        <g >
          <circle cx="1.297" cy="1.297" r="1.297" transform="translate(0 15.56)" fill="none" stroke="#fff" strokeWidth="2" />
          <circle cx="1.297" cy="1.297" r="1.297" transform="translate(16.856 20.746)" fill="none" stroke="#fff" strokeWidth="2" />
          <circle cx="1.297" cy="1.297" r="1.297" transform="translate(33.712 15.56)" fill="none" stroke="#fff" strokeWidth="2" />
          <circle cx="1.297" cy="1.297" r="1.297" transform="translate(50.569)" fill="none" stroke="#fff" strokeWidth="2" />
          <path d="M12.5,17.56l16.856,5.187L46.212,17.56,63.069,2" transform="translate(-11.203 -0.703)" fill="none" stroke="#fff" strokeWidth="2" />
        </g>
      </g>
    </svg>
  );
}
